// extracted by mini-css-extract-plugin
module.exports = {"widgetContainerRight":"NetworkViz_widgetContainerRight__1Zrd4","networkContainer":"NetworkViz_networkContainer__21k0g"};